import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_PREVIOUS_PAYMENTS: MijnRoute = {
    path: 'vorige-afschrijvingen',
    navigationEvent: 'toVorigeHypotheekAfschrijvingen',
    regex: /^\/hypotheek\/vorige-afschrijvingen$/,
    webcomponent: 'mijn-hypotheken-home-webcomponent',
    internalPath: '/vorige-afschrijvingen'
};
